/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TenantSlugRouteImport } from './routes/$tenantSlug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LSecretRouteImport } from './routes/l.$secret'
import { Route as InviteAcceptRouteImport } from './routes/invite.accept'
import { Route as FLinkRouteImport } from './routes/f.$link'
import { Route as AuthTenantSelectRouteImport } from './routes/auth.tenant-select'
import { Route as AuthMfaChallengeRouteImport } from './routes/auth.mfa-challenge'
import { Route as AuthLoginRouteImport } from './routes/auth.login'
import { Route as TenantSlugSettingsRouteImport } from './routes/$tenantSlug.settings'
import { Route as TenantSlugDashboardRouteImport } from './routes/$tenantSlug.dashboard'
import { Route as TenantSlugConciergeRouteImport } from './routes/$tenantSlug.concierge'
import { Route as TenantSlugApprovalsRouteImport } from './routes/$tenantSlug.approvals'
import { Route as TenantSlugSettingsTermsRouteImport } from './routes/$tenantSlug.settings.terms'
import { Route as TenantSlugSettingsTeamRouteImport } from './routes/$tenantSlug.settings.team'
import { Route as TenantSlugSettingsSecurityRouteImport } from './routes/$tenantSlug.settings.security'
import { Route as TenantSlugSettingsRbacRouteImport } from './routes/$tenantSlug.settings.rbac'
import { Route as TenantSlugSettingsOrganizationRouteImport } from './routes/$tenantSlug.settings.organization'
import { Route as TenantSlugSettingsModulesRouteImport } from './routes/$tenantSlug.settings.modules'
import { Route as TenantSlugSettingsModuleListsRouteImport } from './routes/$tenantSlug.settings.module-lists'
import { Route as TenantSlugSettingsListsRouteImport } from './routes/$tenantSlug.settings.lists'
import { Route as TenantSlugSettingsFieldsRouteImport } from './routes/$tenantSlug.settings.fields'
import { Route as TenantSlugAdminPlaygroundRouteImport } from './routes/$tenantSlug.admin.playground'
import { Route as TenantSlugAdminIssuesRouteImport } from './routes/$tenantSlug.admin.issues'
import { Route as TenantSlugAdminExecutionLogRouteImport } from './routes/$tenantSlug.admin.execution-log'
import { Route as TenantSlugAdminDataRouteImport } from './routes/$tenantSlug.admin.data'
import { Route as TenantSlugFormsIdPrintRouteImport } from './routes/$tenantSlug_.forms.$id.print'
import { Route as TenantSlugCollectionIdPrintRouteImport } from './routes/$tenantSlug_.$collection.$id.print'
import { Route as TenantSlugSettingsRbacOverridesRouteImport } from './routes/$tenantSlug.settings.rbac.overrides'

const TenantSlugRoute = TenantSlugRouteImport.update({
  id: '/$tenantSlug',
  path: '/$tenantSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LSecretRoute = LSecretRouteImport.update({
  id: '/l/$secret',
  path: '/l/$secret',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteAcceptRoute = InviteAcceptRouteImport.update({
  id: '/invite/accept',
  path: '/invite/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const FLinkRoute = FLinkRouteImport.update({
  id: '/f/$link',
  path: '/f/$link',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTenantSelectRoute = AuthTenantSelectRouteImport.update({
  id: '/auth/tenant-select',
  path: '/auth/tenant-select',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMfaChallengeRoute = AuthMfaChallengeRouteImport.update({
  id: '/auth/mfa-challenge',
  path: '/auth/mfa-challenge',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantSlugSettingsRoute = TenantSlugSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugDashboardRoute = TenantSlugDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugConciergeRoute = TenantSlugConciergeRouteImport.update({
  id: '/concierge',
  path: '/concierge',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugApprovalsRoute = TenantSlugApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugSettingsTermsRoute = TenantSlugSettingsTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => TenantSlugSettingsRoute,
} as any)
const TenantSlugSettingsTeamRoute = TenantSlugSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => TenantSlugSettingsRoute,
} as any)
const TenantSlugSettingsSecurityRoute =
  TenantSlugSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => TenantSlugSettingsRoute,
  } as any)
const TenantSlugSettingsRbacRoute = TenantSlugSettingsRbacRouteImport.update({
  id: '/rbac',
  path: '/rbac',
  getParentRoute: () => TenantSlugSettingsRoute,
} as any)
const TenantSlugSettingsOrganizationRoute =
  TenantSlugSettingsOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => TenantSlugSettingsRoute,
  } as any)
const TenantSlugSettingsModulesRoute =
  TenantSlugSettingsModulesRouteImport.update({
    id: '/modules',
    path: '/modules',
    getParentRoute: () => TenantSlugSettingsRoute,
  } as any)
const TenantSlugSettingsModuleListsRoute =
  TenantSlugSettingsModuleListsRouteImport.update({
    id: '/module-lists',
    path: '/module-lists',
    getParentRoute: () => TenantSlugSettingsRoute,
  } as any)
const TenantSlugSettingsListsRoute = TenantSlugSettingsListsRouteImport.update({
  id: '/lists',
  path: '/lists',
  getParentRoute: () => TenantSlugSettingsRoute,
} as any)
const TenantSlugSettingsFieldsRoute =
  TenantSlugSettingsFieldsRouteImport.update({
    id: '/fields',
    path: '/fields',
    getParentRoute: () => TenantSlugSettingsRoute,
  } as any)
const TenantSlugAdminPlaygroundRoute =
  TenantSlugAdminPlaygroundRouteImport.update({
    id: '/admin/playground',
    path: '/admin/playground',
    getParentRoute: () => TenantSlugRoute,
  } as any)
const TenantSlugAdminIssuesRoute = TenantSlugAdminIssuesRouteImport.update({
  id: '/admin/issues',
  path: '/admin/issues',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugAdminExecutionLogRoute =
  TenantSlugAdminExecutionLogRouteImport.update({
    id: '/admin/execution-log',
    path: '/admin/execution-log',
    getParentRoute: () => TenantSlugRoute,
  } as any)
const TenantSlugAdminDataRoute = TenantSlugAdminDataRouteImport.update({
  id: '/admin/data',
  path: '/admin/data',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugFormsIdPrintRoute = TenantSlugFormsIdPrintRouteImport.update({
  id: '/$tenantSlug_/forms/$id/print',
  path: '/$tenantSlug/forms/$id/print',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantSlugCollectionIdPrintRoute =
  TenantSlugCollectionIdPrintRouteImport.update({
    id: '/$tenantSlug_/$collection/$id/print',
    path: '/$tenantSlug/$collection/$id/print',
    getParentRoute: () => rootRouteImport,
  } as any)
const TenantSlugSettingsRbacOverridesRoute =
  TenantSlugSettingsRbacOverridesRouteImport.update({
    id: '/overrides',
    path: '/overrides',
    getParentRoute: () => TenantSlugSettingsRbacRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$tenantSlug': typeof TenantSlugRouteWithChildren
  '/$tenantSlug/approvals': typeof TenantSlugApprovalsRoute
  '/$tenantSlug/concierge': typeof TenantSlugConciergeRoute
  '/$tenantSlug/dashboard': typeof TenantSlugDashboardRoute
  '/$tenantSlug/settings': typeof TenantSlugSettingsRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/mfa-challenge': typeof AuthMfaChallengeRoute
  '/auth/tenant-select': typeof AuthTenantSelectRoute
  '/f/$link': typeof FLinkRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/l/$secret': typeof LSecretRoute
  '/$tenantSlug/admin/data': typeof TenantSlugAdminDataRoute
  '/$tenantSlug/admin/execution-log': typeof TenantSlugAdminExecutionLogRoute
  '/$tenantSlug/admin/issues': typeof TenantSlugAdminIssuesRoute
  '/$tenantSlug/admin/playground': typeof TenantSlugAdminPlaygroundRoute
  '/$tenantSlug/settings/fields': typeof TenantSlugSettingsFieldsRoute
  '/$tenantSlug/settings/lists': typeof TenantSlugSettingsListsRoute
  '/$tenantSlug/settings/module-lists': typeof TenantSlugSettingsModuleListsRoute
  '/$tenantSlug/settings/modules': typeof TenantSlugSettingsModulesRoute
  '/$tenantSlug/settings/organization': typeof TenantSlugSettingsOrganizationRoute
  '/$tenantSlug/settings/rbac': typeof TenantSlugSettingsRbacRouteWithChildren
  '/$tenantSlug/settings/security': typeof TenantSlugSettingsSecurityRoute
  '/$tenantSlug/settings/team': typeof TenantSlugSettingsTeamRoute
  '/$tenantSlug/settings/terms': typeof TenantSlugSettingsTermsRoute
  '/$tenantSlug/settings/rbac/overrides': typeof TenantSlugSettingsRbacOverridesRoute
  '/$tenantSlug/$collection/$id/print': typeof TenantSlugCollectionIdPrintRoute
  '/$tenantSlug/forms/$id/print': typeof TenantSlugFormsIdPrintRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$tenantSlug': typeof TenantSlugRouteWithChildren
  '/$tenantSlug/approvals': typeof TenantSlugApprovalsRoute
  '/$tenantSlug/concierge': typeof TenantSlugConciergeRoute
  '/$tenantSlug/dashboard': typeof TenantSlugDashboardRoute
  '/$tenantSlug/settings': typeof TenantSlugSettingsRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/mfa-challenge': typeof AuthMfaChallengeRoute
  '/auth/tenant-select': typeof AuthTenantSelectRoute
  '/f/$link': typeof FLinkRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/l/$secret': typeof LSecretRoute
  '/$tenantSlug/admin/data': typeof TenantSlugAdminDataRoute
  '/$tenantSlug/admin/execution-log': typeof TenantSlugAdminExecutionLogRoute
  '/$tenantSlug/admin/issues': typeof TenantSlugAdminIssuesRoute
  '/$tenantSlug/admin/playground': typeof TenantSlugAdminPlaygroundRoute
  '/$tenantSlug/settings/fields': typeof TenantSlugSettingsFieldsRoute
  '/$tenantSlug/settings/lists': typeof TenantSlugSettingsListsRoute
  '/$tenantSlug/settings/module-lists': typeof TenantSlugSettingsModuleListsRoute
  '/$tenantSlug/settings/modules': typeof TenantSlugSettingsModulesRoute
  '/$tenantSlug/settings/organization': typeof TenantSlugSettingsOrganizationRoute
  '/$tenantSlug/settings/rbac': typeof TenantSlugSettingsRbacRouteWithChildren
  '/$tenantSlug/settings/security': typeof TenantSlugSettingsSecurityRoute
  '/$tenantSlug/settings/team': typeof TenantSlugSettingsTeamRoute
  '/$tenantSlug/settings/terms': typeof TenantSlugSettingsTermsRoute
  '/$tenantSlug/settings/rbac/overrides': typeof TenantSlugSettingsRbacOverridesRoute
  '/$tenantSlug/$collection/$id/print': typeof TenantSlugCollectionIdPrintRoute
  '/$tenantSlug/forms/$id/print': typeof TenantSlugFormsIdPrintRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$tenantSlug': typeof TenantSlugRouteWithChildren
  '/$tenantSlug/approvals': typeof TenantSlugApprovalsRoute
  '/$tenantSlug/concierge': typeof TenantSlugConciergeRoute
  '/$tenantSlug/dashboard': typeof TenantSlugDashboardRoute
  '/$tenantSlug/settings': typeof TenantSlugSettingsRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/mfa-challenge': typeof AuthMfaChallengeRoute
  '/auth/tenant-select': typeof AuthTenantSelectRoute
  '/f/$link': typeof FLinkRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/l/$secret': typeof LSecretRoute
  '/$tenantSlug/admin/data': typeof TenantSlugAdminDataRoute
  '/$tenantSlug/admin/execution-log': typeof TenantSlugAdminExecutionLogRoute
  '/$tenantSlug/admin/issues': typeof TenantSlugAdminIssuesRoute
  '/$tenantSlug/admin/playground': typeof TenantSlugAdminPlaygroundRoute
  '/$tenantSlug/settings/fields': typeof TenantSlugSettingsFieldsRoute
  '/$tenantSlug/settings/lists': typeof TenantSlugSettingsListsRoute
  '/$tenantSlug/settings/module-lists': typeof TenantSlugSettingsModuleListsRoute
  '/$tenantSlug/settings/modules': typeof TenantSlugSettingsModulesRoute
  '/$tenantSlug/settings/organization': typeof TenantSlugSettingsOrganizationRoute
  '/$tenantSlug/settings/rbac': typeof TenantSlugSettingsRbacRouteWithChildren
  '/$tenantSlug/settings/security': typeof TenantSlugSettingsSecurityRoute
  '/$tenantSlug/settings/team': typeof TenantSlugSettingsTeamRoute
  '/$tenantSlug/settings/terms': typeof TenantSlugSettingsTermsRoute
  '/$tenantSlug/settings/rbac/overrides': typeof TenantSlugSettingsRbacOverridesRoute
  '/$tenantSlug_/$collection/$id/print': typeof TenantSlugCollectionIdPrintRoute
  '/$tenantSlug_/forms/$id/print': typeof TenantSlugFormsIdPrintRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$tenantSlug'
    | '/$tenantSlug/approvals'
    | '/$tenantSlug/concierge'
    | '/$tenantSlug/dashboard'
    | '/$tenantSlug/settings'
    | '/auth/login'
    | '/auth/mfa-challenge'
    | '/auth/tenant-select'
    | '/f/$link'
    | '/invite/accept'
    | '/l/$secret'
    | '/$tenantSlug/admin/data'
    | '/$tenantSlug/admin/execution-log'
    | '/$tenantSlug/admin/issues'
    | '/$tenantSlug/admin/playground'
    | '/$tenantSlug/settings/fields'
    | '/$tenantSlug/settings/lists'
    | '/$tenantSlug/settings/module-lists'
    | '/$tenantSlug/settings/modules'
    | '/$tenantSlug/settings/organization'
    | '/$tenantSlug/settings/rbac'
    | '/$tenantSlug/settings/security'
    | '/$tenantSlug/settings/team'
    | '/$tenantSlug/settings/terms'
    | '/$tenantSlug/settings/rbac/overrides'
    | '/$tenantSlug/$collection/$id/print'
    | '/$tenantSlug/forms/$id/print'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$tenantSlug'
    | '/$tenantSlug/approvals'
    | '/$tenantSlug/concierge'
    | '/$tenantSlug/dashboard'
    | '/$tenantSlug/settings'
    | '/auth/login'
    | '/auth/mfa-challenge'
    | '/auth/tenant-select'
    | '/f/$link'
    | '/invite/accept'
    | '/l/$secret'
    | '/$tenantSlug/admin/data'
    | '/$tenantSlug/admin/execution-log'
    | '/$tenantSlug/admin/issues'
    | '/$tenantSlug/admin/playground'
    | '/$tenantSlug/settings/fields'
    | '/$tenantSlug/settings/lists'
    | '/$tenantSlug/settings/module-lists'
    | '/$tenantSlug/settings/modules'
    | '/$tenantSlug/settings/organization'
    | '/$tenantSlug/settings/rbac'
    | '/$tenantSlug/settings/security'
    | '/$tenantSlug/settings/team'
    | '/$tenantSlug/settings/terms'
    | '/$tenantSlug/settings/rbac/overrides'
    | '/$tenantSlug/$collection/$id/print'
    | '/$tenantSlug/forms/$id/print'
  id:
    | '__root__'
    | '/'
    | '/$tenantSlug'
    | '/$tenantSlug/approvals'
    | '/$tenantSlug/concierge'
    | '/$tenantSlug/dashboard'
    | '/$tenantSlug/settings'
    | '/auth/login'
    | '/auth/mfa-challenge'
    | '/auth/tenant-select'
    | '/f/$link'
    | '/invite/accept'
    | '/l/$secret'
    | '/$tenantSlug/admin/data'
    | '/$tenantSlug/admin/execution-log'
    | '/$tenantSlug/admin/issues'
    | '/$tenantSlug/admin/playground'
    | '/$tenantSlug/settings/fields'
    | '/$tenantSlug/settings/lists'
    | '/$tenantSlug/settings/module-lists'
    | '/$tenantSlug/settings/modules'
    | '/$tenantSlug/settings/organization'
    | '/$tenantSlug/settings/rbac'
    | '/$tenantSlug/settings/security'
    | '/$tenantSlug/settings/team'
    | '/$tenantSlug/settings/terms'
    | '/$tenantSlug/settings/rbac/overrides'
    | '/$tenantSlug_/$collection/$id/print'
    | '/$tenantSlug_/forms/$id/print'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TenantSlugRoute: typeof TenantSlugRouteWithChildren
  AuthLoginRoute: typeof AuthLoginRoute
  AuthMfaChallengeRoute: typeof AuthMfaChallengeRoute
  AuthTenantSelectRoute: typeof AuthTenantSelectRoute
  FLinkRoute: typeof FLinkRoute
  InviteAcceptRoute: typeof InviteAcceptRoute
  LSecretRoute: typeof LSecretRoute
  TenantSlugCollectionIdPrintRoute: typeof TenantSlugCollectionIdPrintRoute
  TenantSlugFormsIdPrintRoute: typeof TenantSlugFormsIdPrintRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$tenantSlug': {
      id: '/$tenantSlug'
      path: '/$tenantSlug'
      fullPath: '/$tenantSlug'
      preLoaderRoute: typeof TenantSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/l/$secret': {
      id: '/l/$secret'
      path: '/l/$secret'
      fullPath: '/l/$secret'
      preLoaderRoute: typeof LSecretRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/accept': {
      id: '/invite/accept'
      path: '/invite/accept'
      fullPath: '/invite/accept'
      preLoaderRoute: typeof InviteAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/f/$link': {
      id: '/f/$link'
      path: '/f/$link'
      fullPath: '/f/$link'
      preLoaderRoute: typeof FLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/tenant-select': {
      id: '/auth/tenant-select'
      path: '/auth/tenant-select'
      fullPath: '/auth/tenant-select'
      preLoaderRoute: typeof AuthTenantSelectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/mfa-challenge': {
      id: '/auth/mfa-challenge'
      path: '/auth/mfa-challenge'
      fullPath: '/auth/mfa-challenge'
      preLoaderRoute: typeof AuthMfaChallengeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantSlug/settings': {
      id: '/$tenantSlug/settings'
      path: '/settings'
      fullPath: '/$tenantSlug/settings'
      preLoaderRoute: typeof TenantSlugSettingsRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/dashboard': {
      id: '/$tenantSlug/dashboard'
      path: '/dashboard'
      fullPath: '/$tenantSlug/dashboard'
      preLoaderRoute: typeof TenantSlugDashboardRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/concierge': {
      id: '/$tenantSlug/concierge'
      path: '/concierge'
      fullPath: '/$tenantSlug/concierge'
      preLoaderRoute: typeof TenantSlugConciergeRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/approvals': {
      id: '/$tenantSlug/approvals'
      path: '/approvals'
      fullPath: '/$tenantSlug/approvals'
      preLoaderRoute: typeof TenantSlugApprovalsRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/settings/terms': {
      id: '/$tenantSlug/settings/terms'
      path: '/terms'
      fullPath: '/$tenantSlug/settings/terms'
      preLoaderRoute: typeof TenantSlugSettingsTermsRouteImport
      parentRoute: typeof TenantSlugSettingsRoute
    }
    '/$tenantSlug/settings/team': {
      id: '/$tenantSlug/settings/team'
      path: '/team'
      fullPath: '/$tenantSlug/settings/team'
      preLoaderRoute: typeof TenantSlugSettingsTeamRouteImport
      parentRoute: typeof TenantSlugSettingsRoute
    }
    '/$tenantSlug/settings/security': {
      id: '/$tenantSlug/settings/security'
      path: '/security'
      fullPath: '/$tenantSlug/settings/security'
      preLoaderRoute: typeof TenantSlugSettingsSecurityRouteImport
      parentRoute: typeof TenantSlugSettingsRoute
    }
    '/$tenantSlug/settings/rbac': {
      id: '/$tenantSlug/settings/rbac'
      path: '/rbac'
      fullPath: '/$tenantSlug/settings/rbac'
      preLoaderRoute: typeof TenantSlugSettingsRbacRouteImport
      parentRoute: typeof TenantSlugSettingsRoute
    }
    '/$tenantSlug/settings/organization': {
      id: '/$tenantSlug/settings/organization'
      path: '/organization'
      fullPath: '/$tenantSlug/settings/organization'
      preLoaderRoute: typeof TenantSlugSettingsOrganizationRouteImport
      parentRoute: typeof TenantSlugSettingsRoute
    }
    '/$tenantSlug/settings/modules': {
      id: '/$tenantSlug/settings/modules'
      path: '/modules'
      fullPath: '/$tenantSlug/settings/modules'
      preLoaderRoute: typeof TenantSlugSettingsModulesRouteImport
      parentRoute: typeof TenantSlugSettingsRoute
    }
    '/$tenantSlug/settings/module-lists': {
      id: '/$tenantSlug/settings/module-lists'
      path: '/module-lists'
      fullPath: '/$tenantSlug/settings/module-lists'
      preLoaderRoute: typeof TenantSlugSettingsModuleListsRouteImport
      parentRoute: typeof TenantSlugSettingsRoute
    }
    '/$tenantSlug/settings/lists': {
      id: '/$tenantSlug/settings/lists'
      path: '/lists'
      fullPath: '/$tenantSlug/settings/lists'
      preLoaderRoute: typeof TenantSlugSettingsListsRouteImport
      parentRoute: typeof TenantSlugSettingsRoute
    }
    '/$tenantSlug/settings/fields': {
      id: '/$tenantSlug/settings/fields'
      path: '/fields'
      fullPath: '/$tenantSlug/settings/fields'
      preLoaderRoute: typeof TenantSlugSettingsFieldsRouteImport
      parentRoute: typeof TenantSlugSettingsRoute
    }
    '/$tenantSlug/admin/playground': {
      id: '/$tenantSlug/admin/playground'
      path: '/admin/playground'
      fullPath: '/$tenantSlug/admin/playground'
      preLoaderRoute: typeof TenantSlugAdminPlaygroundRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/admin/issues': {
      id: '/$tenantSlug/admin/issues'
      path: '/admin/issues'
      fullPath: '/$tenantSlug/admin/issues'
      preLoaderRoute: typeof TenantSlugAdminIssuesRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/admin/execution-log': {
      id: '/$tenantSlug/admin/execution-log'
      path: '/admin/execution-log'
      fullPath: '/$tenantSlug/admin/execution-log'
      preLoaderRoute: typeof TenantSlugAdminExecutionLogRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/admin/data': {
      id: '/$tenantSlug/admin/data'
      path: '/admin/data'
      fullPath: '/$tenantSlug/admin/data'
      preLoaderRoute: typeof TenantSlugAdminDataRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug_/forms/$id/print': {
      id: '/$tenantSlug_/forms/$id/print'
      path: '/$tenantSlug/forms/$id/print'
      fullPath: '/$tenantSlug/forms/$id/print'
      preLoaderRoute: typeof TenantSlugFormsIdPrintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantSlug_/$collection/$id/print': {
      id: '/$tenantSlug_/$collection/$id/print'
      path: '/$tenantSlug/$collection/$id/print'
      fullPath: '/$tenantSlug/$collection/$id/print'
      preLoaderRoute: typeof TenantSlugCollectionIdPrintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantSlug/settings/rbac/overrides': {
      id: '/$tenantSlug/settings/rbac/overrides'
      path: '/overrides'
      fullPath: '/$tenantSlug/settings/rbac/overrides'
      preLoaderRoute: typeof TenantSlugSettingsRbacOverridesRouteImport
      parentRoute: typeof TenantSlugSettingsRbacRoute
    }
  }
}

interface TenantSlugSettingsRbacRouteChildren {
  TenantSlugSettingsRbacOverridesRoute: typeof TenantSlugSettingsRbacOverridesRoute
}

const TenantSlugSettingsRbacRouteChildren: TenantSlugSettingsRbacRouteChildren =
  {
    TenantSlugSettingsRbacOverridesRoute: TenantSlugSettingsRbacOverridesRoute,
  }

const TenantSlugSettingsRbacRouteWithChildren =
  TenantSlugSettingsRbacRoute._addFileChildren(
    TenantSlugSettingsRbacRouteChildren,
  )

interface TenantSlugSettingsRouteChildren {
  TenantSlugSettingsFieldsRoute: typeof TenantSlugSettingsFieldsRoute
  TenantSlugSettingsListsRoute: typeof TenantSlugSettingsListsRoute
  TenantSlugSettingsModuleListsRoute: typeof TenantSlugSettingsModuleListsRoute
  TenantSlugSettingsModulesRoute: typeof TenantSlugSettingsModulesRoute
  TenantSlugSettingsOrganizationRoute: typeof TenantSlugSettingsOrganizationRoute
  TenantSlugSettingsRbacRoute: typeof TenantSlugSettingsRbacRouteWithChildren
  TenantSlugSettingsSecurityRoute: typeof TenantSlugSettingsSecurityRoute
  TenantSlugSettingsTeamRoute: typeof TenantSlugSettingsTeamRoute
  TenantSlugSettingsTermsRoute: typeof TenantSlugSettingsTermsRoute
}

const TenantSlugSettingsRouteChildren: TenantSlugSettingsRouteChildren = {
  TenantSlugSettingsFieldsRoute: TenantSlugSettingsFieldsRoute,
  TenantSlugSettingsListsRoute: TenantSlugSettingsListsRoute,
  TenantSlugSettingsModuleListsRoute: TenantSlugSettingsModuleListsRoute,
  TenantSlugSettingsModulesRoute: TenantSlugSettingsModulesRoute,
  TenantSlugSettingsOrganizationRoute: TenantSlugSettingsOrganizationRoute,
  TenantSlugSettingsRbacRoute: TenantSlugSettingsRbacRouteWithChildren,
  TenantSlugSettingsSecurityRoute: TenantSlugSettingsSecurityRoute,
  TenantSlugSettingsTeamRoute: TenantSlugSettingsTeamRoute,
  TenantSlugSettingsTermsRoute: TenantSlugSettingsTermsRoute,
}

const TenantSlugSettingsRouteWithChildren =
  TenantSlugSettingsRoute._addFileChildren(TenantSlugSettingsRouteChildren)

interface TenantSlugRouteChildren {
  TenantSlugApprovalsRoute: typeof TenantSlugApprovalsRoute
  TenantSlugConciergeRoute: typeof TenantSlugConciergeRoute
  TenantSlugDashboardRoute: typeof TenantSlugDashboardRoute
  TenantSlugSettingsRoute: typeof TenantSlugSettingsRouteWithChildren
  TenantSlugAdminDataRoute: typeof TenantSlugAdminDataRoute
  TenantSlugAdminExecutionLogRoute: typeof TenantSlugAdminExecutionLogRoute
  TenantSlugAdminIssuesRoute: typeof TenantSlugAdminIssuesRoute
  TenantSlugAdminPlaygroundRoute: typeof TenantSlugAdminPlaygroundRoute
}

const TenantSlugRouteChildren: TenantSlugRouteChildren = {
  TenantSlugApprovalsRoute: TenantSlugApprovalsRoute,
  TenantSlugConciergeRoute: TenantSlugConciergeRoute,
  TenantSlugDashboardRoute: TenantSlugDashboardRoute,
  TenantSlugSettingsRoute: TenantSlugSettingsRouteWithChildren,
  TenantSlugAdminDataRoute: TenantSlugAdminDataRoute,
  TenantSlugAdminExecutionLogRoute: TenantSlugAdminExecutionLogRoute,
  TenantSlugAdminIssuesRoute: TenantSlugAdminIssuesRoute,
  TenantSlugAdminPlaygroundRoute: TenantSlugAdminPlaygroundRoute,
}

const TenantSlugRouteWithChildren = TenantSlugRoute._addFileChildren(
  TenantSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TenantSlugRoute: TenantSlugRouteWithChildren,
  AuthLoginRoute: AuthLoginRoute,
  AuthMfaChallengeRoute: AuthMfaChallengeRoute,
  AuthTenantSelectRoute: AuthTenantSelectRoute,
  FLinkRoute: FLinkRoute,
  InviteAcceptRoute: InviteAcceptRoute,
  LSecretRoute: LSecretRoute,
  TenantSlugCollectionIdPrintRoute: TenantSlugCollectionIdPrintRoute,
  TenantSlugFormsIdPrintRoute: TenantSlugFormsIdPrintRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
